export default __webpack_public_path__ + "static/media/sportsbra-medium-front-toobig.2c2b3c0b.jpg";